import {LogoListCarouselComponent} from "./components/logo-list-carousel";
import {ComponentService} from "./service/component";
import {Application} from "./application/application";
require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {
    let components = new ComponentService();
    components.addComponent('.js-logo-list-carousel', LogoListCarouselComponent, 'LogoListCarouselComponent');
    new Application(components);
}))(jQuery);
